import { DenseOrderConfirmationInvoice } from "@/features/invoices/order-confirmation-invoices/order-confirmation-invoice.type";
import { IdentityParameter } from "@/features/types";
import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import { AxiosRequestConfig } from "axios";
import { UrlParser } from "@/features/ui/helpers/url-parser";
import { StringTransformer } from "@/features/ui/helpers/string-transformer";
import useGetDenseOrderConfirmationFetcher from "@/features/invoices/order-confirmation-invoices/hooks/use-get-dense-order-confirmation-fetcher";
import useSWR, { SWRConfiguration } from "swr";

export interface GetDenseOrderConfirmationInvoiceParameter
  extends IdentityParameter {
  orderConfirmationInvoiceId: number;
}
export interface GetDenseOrderConfirmationInvoiceRequest {
  // 송금 요청을 다시 불러 연결 OC·PF(와 그 오더·라인시트)까지 채우지 않는다.
  // OC 응답의 payments 에 송금 정보(보낸·받는 쪽, 금액, 영수증)가 이미 있어 수정 모달은 이것으로 충분하다.
  skipDensePayments?: boolean;
  // 연결 오더를 다시 불러(오더 + 라인시트) 채우지 않는다 — 수정 모달은 오더 id 만 쓴다.
  // (오더의 부티크 컨펌 정보로 브랜드별 행을 만드는 건 새로 올릴 때뿐이다)
  skipOrderSheetSets?: boolean;
}
export interface GetDenseOrderDenseConfirmationInvoiceResponse
  extends DenseOrderConfirmationInvoice {}

export const getDenseOrderConfirmationInvoiceTemplateUrl = `/:by/:companyId/dense-order-confirmation-invoices/:orderConfirmationInvoiceId`;

export function getGetDenseOrderConfirmationInvoiceKey(
  parameter?: GetDenseOrderConfirmationInvoiceParameter,
  request?: GetDenseOrderConfirmationInvoiceRequest
) {
  if (parameter && request) {
    return {
      url: calcUrl(getDenseOrderConfirmationInvoiceTemplateUrl, parameter),
      params: request,
    };
  }
  return null;
}

export function parseGetDenseOrderConfirmationInvoiceKey(
  key: AxiosRequestConfig<GetDenseOrderConfirmationInvoiceRequest>
) {
  const urlParser = new UrlParser<GetDenseOrderConfirmationInvoiceParameter>(
    getDenseOrderConfirmationInvoiceTemplateUrl,
    {
      by: StringTransformer.parseBy,
      companyId: StringTransformer.parseId,
      orderConfirmationInvoiceId: StringTransformer.parseId,
    }
  );

  return {
    parameter: urlParser.parse(key.url!!),
    request: key.params,
  };
}

export default function useGetDenseOrderConfirmationInvoice(
  parameter?: GetDenseOrderConfirmationInvoiceParameter,
  request?: GetDenseOrderConfirmationInvoiceRequest,
  config?: SWRConfiguration<GetDenseOrderDenseConfirmationInvoiceResponse>
) {
  const fetcher = useGetDenseOrderConfirmationFetcher();
  return useSWR(
    getGetDenseOrderConfirmationInvoiceKey(parameter, request),
    fetcher,
    config
  );
}
